import React, { Ref, forwardRef, useImperativeHandle, useState } from "react";
import {
    Backdrop,
    Box,
    Button,
    IconButton,
    Modal,
    Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Close from "@mui/icons-material/Close";
import styles from "./MembershipCanceledModal.module.scss";
import useWindowSize from "Hooks/useWindowSize";
import useQueryParams from "Hooks/useQueryParams";
import { useHistory } from "react-router-dom";
import { CONSTANTS } from "consts";

const useStyles: any = makeStyles({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
});

export interface IMembershipCanceledModalRef {
    isVisible: boolean;
    setIsVisible: (value: boolean) => void;
}

interface MembershipCanceledModalProps {}

const MembershipCanceledModal = (
    props: MembershipCanceledModalProps,
    ref: Ref<IMembershipCanceledModalRef>
) => {
    const { id } = useQueryParams();
    const history = useHistory();
    const isDesktop = useWindowSize(1280).width > 768;
    const classes = useStyles();

    const [isVisible, setIsVisible] = useState<boolean>(false);

    const handleClose = () => {
        setIsVisible(false);
        history.replace(`${CONSTANTS.NAVIGATION_URL.MEMBERSHIPS}/${id}`);
    };

    useImperativeHandle(
        ref,
        () => ({
            isVisible,
            setIsVisible,
        }),
        [isVisible]
    );

    return (
        <Modal
            open={isVisible}
            onClose={handleClose}
            className={classes.modal}
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            closeAfterTransition
            BackdropComponent={Backdrop}
        >
            <div className={styles["membership-canceled-modal"]}>
                <IconButton
                    onClick={handleClose}
                    className={styles["close-button"]}
                >
                    <Close />
                </IconButton>
                <Box>
                    <div className={styles["membership-canceled-modal-image"]}>
                        <img
                            src="/images/membership/membership-canceled.webp"
                            alt="canceled"
                        />
                    </div>
                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: {
                                xs: "20px",
                                md: "24px",
                            },
                            lineHeight: {
                                xs: "20px",
                                md: "24.48px",
                            },
                            letterSpacing: "0.01em",
                            textAlign: "center",
                            color: "#161616",
                            marginBottom: "24px",
                            fontFamily: "GRIFTER",
                        }}
                    >
                        MEMBERSHIP CANCELED
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: "16px",
                            lineHeight: "20px",
                            alignItems: "center",
                            textAlign: "center",
                            marginBottom: {
                                xs: "32px",
                                md: "56px",
                            },
                        }}
                    >
                        We’re sorry to see you go. Your journey doesn’t have to
                        end here.
                        {isDesktop && <br />}
                        If you ever decide to return, we’ll always be here for
                        you.
                    </Typography>
                </Box>
                <Box
                    sx={{
                        textAlign: "center",
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={handleClose}
                        color="secondary"
                        fullWidth
                        sx={{
                            marginBottom: "24px",
                            width: {
                                xs: "100%",
                                md: "70%",
                            },
                            margin: "auto",
                        }}
                    >
                        OK
                    </Button>
                </Box>
            </div>
        </Modal>
    );
};

export default forwardRef(MembershipCanceledModal);
